import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import TeamGroup from './TeamGroup';

export default class TeamSection extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    list: PropTypes.array,
    invite: PropTypes.bool,
  };
  render() {
    const {title, icon, list, invite} = this.props;
    const teams = [];
    const initList = list || [];
    for (let x = 0; x < initList.length; x++) {
      const memberList = list[x].member;
      const key = `team-${x}`;
      teams.push(<TeamGroup key={key} membersList={memberList} />);
    }
    const groupClass = classNames('teams-section', {invite});
    return (
      <section className={groupClass}>
        {title ? (
          <div className="title-section text-center">
            <img src={icon} alt={title} />
            <h2>{title}</h2>
          </div>
        ) : null}
        <div className="teams">
          <div className="row">{teams}</div>
        </div>
      </section>
    );
  }
}
